import DataManager from '../../data/DataManager'
import Main from '../../Main'
import TopView from  './view/TopView'
import GameView from  './view/GameView'
import OverView from '../../view/OverView';
import Share from '../../sns/Share'

class App
{
  // ---------------------------------------------------------------------------------------------------------
	// --	App
	// ---------------------------------------------------------------------------------------------------------

  constructor()
  {
    console.log("App-game-pongpong")

    //DBの設定
    DataManager.setData('APPLICATION_KEY', '09b743084ee7c040d939d259c2a4d1a59eff42123447e6f0767f17d621cde701');
    DataManager.setData('CLIENT_KEY', '310aa9136d45ad68e21225c0ade84fb4880be72a8d0579aa64fbb52a7dd17055');

    //Mainクラス初期化
    this.main = new Main(this);
    this.main.on('init', this.onInit.bind(this));
    this.main.on('resize', this.onResize.bind(this));
  }

  /**
   * Mainの初期化完了
   */
  onInit(data)
  {
    //参照保持
    this.app = data.app;
    this.root = data.root;

		//ゲーム生成
		this.game = new GameView();
		this.root.addChild(this.game);

    //TOP生成
    this.top = new TopView();
    this.top.on('start', this.onStart.bind(this));
    this.root.addChild(this.top);

    //リトライ
    OverView.on('retry', this.onRetry.bind(this));

    //シェア
    OverView.on('tweet', (scoreStr)=>{
      Share.tweet("【SPACE PONG PONG】で" + scoreStr + "ポイントゲット！");
    });

    //トップ開く
    this.top.open();
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	ゲーム開始
	// ---------------------------------------------------------------------------------------------------------

  /**
  *　ゲームスタート
  **/
  onStart()
  {
    //トップ閉じる
    this.top.close();
    
    //ゲーム
    this.game.open();
  }

  // ---------------------------------------------------------------------------------------------------------
	// --	リトライ
  // ---------------------------------------------------------------------------------------------------------

  onRetry()
  {
    //オーバー画面閉じる
    OverView.close()
    
    //ゲーム
    this.game.reset()
    this.game.open()
  }

  // ---------------------------------------------------------------------------------------------------------
	// --	リサイズ
	// ---------------------------------------------------------------------------------------------------------

  /**
   * リサイズハンドリング
   */
  onResize()
  {
    this.top.resize();
    this.game.resize();
  }

	// ---------------------------------------------------------------------------------------------------------
}

window.app = new App();